import { getGlobal, setGlobal } from './persistence/global';
const typeMetadataQFStateKey = 'quickFetchedTypeMetadataRequests';
export const getTypeMetadataQuickFetches = () => getGlobal(typeMetadataQFStateKey) || new Map();
export const setTypeMetadataQuickFetches = value => setGlobal(typeMetadataQFStateKey, value);
const removeTypeMetadataQuickFetch = appSettingName => {
  const quickFetches = getTypeMetadataQuickFetches();
  quickFetches.delete(appSettingName);
  setTypeMetadataQuickFetches(quickFetches);
};
export const takeTypeMetadataQuickFetch = appSettingName => {
  const quickFetches = getTypeMetadataQuickFetches();
  const value = quickFetches.get(appSettingName);
  removeTypeMetadataQuickFetch(appSettingName);
  return value;
};